import React, { useState, useEffect } from 'react';
import './index.scss';
import Lottie from 'lottie-react';
import { tLoader } from '@/Utils/i18n';
import { languageManager } from '@/Utils/languageManager';

const translations = {
    en: {
        "Learn Korean with a": "Learn Korean with a",
        "smarter and friendlier": "smarter and friendlier",
        "Mate, and receive": "Mate, and receive",
        "unlimited Mate images": "unlimited Mate images",
        "!": "!",
        "If the": "If the",
        "app version is 1.6.1": "app version is 1.6.1",
        ", enjoy unlimited chat with Mate!": ", enjoy unlimited chat with Mate!",
        "Please check your": "Please check your",
        "app version": "app version",
        "If you scroll down on the My Page tab, you can check the version. To enjoy unlimited chat, the app version must be 1.6.1.": "If you scroll down on the My Page tab, you can check the version. To enjoy unlimited chat, the app version must be 1.6.1."
    },
    id: {
        "Learn Korean with a": "Belajar bahasa Korea dengan Mate yang",
        "smarter and friendlier": "lebih pintar dan ramah",
        "Mate, and receive": ", dan terima",
        "unlimited Mate images": "gambar Mate tanpa batas",
        "!": "!",
        "If the": "Jika",
        "app version is 1.6.1": "versi aplikasi adalah 1.6.1",
        ", enjoy unlimited chat with Mate!": ", nikmati chat tanpa batas dengan Mate!",
        "Please check your": "Silakan cek",
        "app version": "versi aplikasi",
        "If you scroll down on the My Page tab, you can check the version. To enjoy unlimited chat, the app version must be 1.6.1.": "Jika Anda menggulir ke bawah pada tab My Page, Anda dapat memeriksa versinya. Untuk menikmati chat tanpa batas, versi aplikasi harus 1.6.1."
    },
    ko: {
        "Learn Korean with a": "더 똑똑하고 친근한",
        "smarter and friendlier": "메이트와 함께",
        "Mate, and receive": "한국어를 배우고,",
        "unlimited Mate images": "무제한 메이트 이미지",
        "!": "를 받으세요!",
        "If the": "만약",
        "app version is 1.6.1": "앱 버전이 1.6.1",
        ", enjoy unlimited chat with Mate!": "이라면, 메이트와 무제한 채팅을 즐기세요!",
        "Please check your": "확인해주세요",
        "app version": "앱 버전",
        "If you scroll down on the My Page tab, you can check the version. To enjoy unlimited chat, the app version must be 1.6.1.": "마이페이지 탭에서 아래로 스크롤하면 버전을 확인할 수 있습니다. 무제한 채팅을 즐기려면 앱 버전이 1.6.1이어야 합니다."
    },
    vn: {
        "Learn Korean with a": "Học tiếng Hàn với Mate",
        "smarter and friendlier": "thông minh hơn và thân thiện hơn",
        "Mate, and receive": ", và nhận",
        "unlimited Mate images": "hình ảnh Mate không giới hạn",
        "!": "!",
        "If the": "Nếu",
        "app version is 1.6.1": "phiên bản ứng dụng là 1.6.1",
        ", enjoy unlimited chat with Mate!": ", hãy tận hưởng trò chuyện không giới hạn với Mate!",
        "Please check your": "Vui lòng kiểm tra",
        "app version": "phiên bản ứng dụng",
        "If you scroll down on the My Page tab, you can check the version. To enjoy unlimited chat, the app version must be 1.6.1.": "Nếu bạn cuộn xuống tab Trang của tôi, bạn có thể kiểm tra phiên bản. Để tận hưởng trò chuyện không giới hạn, phiên bản ứng dụng phải là 1.6.1."
    }
};

const UnlimitedChat251006: React.FC = () => {
    const [animationData, setAnimationData] = useState(null);
    const [, forceUpdate] = useState({});
    const t = tLoader(translations);

    useEffect(() => {
        const unsubscribe = languageManager.subscribe(() => forceUpdate({}));
        return unsubscribe;
    }, []);

    useEffect(() => {
        fetch('https://static.koreanmate.app/notice/251006-unlimitchat/applicaiton.json')
            .then(response => response.json())
            .then(data => setAnimationData(data))
            .catch(error => console.error('Error loading animation:', error));
    }, []);

    return (
        <div className="unlimited-chat-page">

            <div className="top-section">
                <div className="lottie-container">
                    <Lottie
                        animationData={animationData}
                        loop={true}
                        autoplay={true}
                        style={{ width: '100%', height: '100%' }}
                    />
                </div>
            </div>

            <div className="smart-mate-container">
                <p className="smart-mate-title">
                    {t("Learn Korean with a")}<span className="highlight">{t("smarter and friendlier")}</span>{t("Mate, and receive")}<span className="highlight">{t("unlimited Mate images")}</span>{t("!")}
                </p>

                <div className="chat-detail-container">
                    <img src="https://static.koreanmate.app/notice/251006-unlimitchat/chatdetail.png" alt="Chat Detail Interface" className="chat-detail-image" />
                </div>
            </div>

            <div className="chat-promotion-container">
                <p className="chat-promotion-title">
                    {t("If the")}<span className="highlight">{t("app version is 1.6.1")}</span>{t(", enjoy unlimited chat with Mate!")}
                </p>

                <div className="chat-images-container">
                    <img src="https://static.koreanmate.app/notice/251006-unlimitchat/chatimg.png" alt="Chat Interface" className="chat-image" />
                </div>
            </div>

            <div className="version-check-container">
                <p className="version-title">
                    {t("Please check your")}<span className="highlight">{t("app version")}</span>{t("!")}
                </p>

                <div className="image-container">
                    <img src="https://static.koreanmate.app/notice/251006-unlimitchat/bottom_of_my.png" alt="App Version Check" className="main-image" />
                </div>

                <div className="description-text">
                    <p>{t("If you scroll down on the My Page tab, you can check the version. To enjoy unlimited chat, the app version must be 1.6.1.")}</p>
                </div>
            </div>
        </div>
    );
};

export default UnlimitedChat251006;